module.exports = __webpack_public_path__ + "img/schedule_sp.2c940e31.svg";